import { useAuth } from '../hooks/useAuth';
import { MyItinerariesList } from '../components/itinerary/MyItinerariesList';
import { ItinerariesSignedOutCTA } from '../components/itinerary/ItinerariesSignedOutCTA';

/**
 * `/itineraries` — the My Itineraries list (plan U5) for signed-in users, and
 * a sign-up CTA for everyone else (issue #247). The anonymous branch must not
 * render MyItinerariesList at all: gating only the markup would still fire
 * `itinerary.listMine` and surface its 401 as an error banner.
 */
export const Itineraries = () => {
  const { isLoading, isAuthenticated } = useAuth();

  // OnboardingGuard already blocks on the auth check, but rendering nothing
  // here keeps the CTA from flashing at a signed-in user if that ever changes.
  if (isLoading) return null;

  return isAuthenticated ? <MyItinerariesList /> : <ItinerariesSignedOutCTA />;
};
